import { useLayoutEffect, useRef, useState } from 'react';

export function useFooterSectionHeight() {
  const [gridMaxHeight, setGridMaxHeight] = useState(0);

  const detailsRef = useRef(null);

  const updateGridMaxHeight = () => {
    if (detailsRef.current) setGridMaxHeight(detailsRef.current.offsetHeight);
  };

  useLayoutEffect(() => {
    updateGridMaxHeight();
  }, []);

  return {
    gridMaxHeight,
    updateGridMaxHeight,
    detailsRef,
  };
}
